module.exports = __webpack_public_path__ + "img/service-head-bg-2.b5e08231.jpg";